var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 50 50",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.9 26.7v-4.4",
    fill: "#fa4968"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.6 1.5-3.9 5.3h2.3v20c0 7.9-6.4 14.3-14.3 14.3v1.6h7.2c6-2.8 10.2-8.8 10.2-15.9l.1-20h2.3z",
    fill: "#fa4968"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.5 42.6-5.3-3.9v2.3h-19.9c-7.9 0-14.3-6.4-14.3-14.3h-3.1c0 9.7 7.8 17.5 17.4 17.5l19.9.1v2.3z",
    fill: "#f76861"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.4 48.5 3.9-5.3h-2.2v-20c0-7.9 6.4-14.3 14.3-14.3v-3.1c-9.6 0-17.4 7.8-17.4 17.5l-.1 20h-2.4z",
    fill: "#abb734"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 13.2v9.3c-.4-7.5-6.7-13.5-14.3-13.5h-19.9v2.3l-5.3-4 5.3-3.9v2.3l19.9.1c5.9 0 11.1 2.9 14.3 7.4z",
    fill: "#ffb95c"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.5 27.7c-.3 1.3-.8 2.5-1.5 3.6-1.3-.5-2.6-.3-3.3.4-.8.8-.9 2.1-.4 3.4-1.1.7-2.3 1.2-3.5 1.5-.6-1.3-1.6-2.1-2.7-2.1s-2.1.8-2.7 2.1c-1.3-.3-2.5-.8-3.5-1.5.5-1.3.3-2.6-.4-3.4-.8-.8-2.1-.9-3.4-.4-.7-1.1-1.2-2.3-1.5-3.6 1.3-.6 2.1-1.6 2.1-2.7s-.8-2.1-2.1-2.7c.3-1.3.8-2.5 1.5-3.6 1.3.5 2.6.3 3.4-.4.8-.8.9-2.1.4-3.4 1.1-.7 2.3-1.2 3.5-1.5.6 1.3 1.6 2.1 2.7 2.1s2.1-.8 2.7-2.1c1.3.3 2.5.8 3.5 1.5-.5 1.3-.3 2.6.4 3.4.8.8 2.1.9 3.4.4.7 1.1 1.2 2.3 1.5 3.6-1.2.6-2.1 1.6-2.1 2.7s.8 2.1 2 2.7z",
    fill: "#559aff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25,
    fill: "#fff",
    rx: 5.3,
    ry: 5.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.1bf25b3647e70c28bbbf621cfd898a5f.svg";
export { ForwardRef as ReactComponent };